/* HŌCHA — storefront behaviour. No dependencies. */
(() => {
  const d = document, root = d.documentElement;
  root.classList.remove('no-js');
  const cfg = window.HOCHA || {};
  const money = (cents) => {
    const v = (cents / 100).toFixed(2);
    return (cfg.currencySymbol || '£') + v;
  };

  /* Hero load + header shadow */
  window.addEventListener('load', () => root.classList.add('is-loaded'));
  const header = d.querySelector('.site-header');
  const onScroll = () => header && header.classList.toggle('is-scrolled', window.scrollY > 8);
  onScroll(); window.addEventListener('scroll', onScroll, { passive: true });

  /* Reveal on scroll */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -8% 0px', threshold: .08 });
    d.querySelectorAll('.reveal').forEach((el) => io.observe(el));
  } else d.querySelectorAll('.reveal').forEach((el) => el.classList.add('is-in'));

  /* Drawers */
  let lastFocus = null;
  const openDrawer = (id) => {
    const el = d.getElementById(id); if (!el) return;
    lastFocus = d.activeElement;
    el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false');
    root.classList.add('no-scroll');
    const f = el.querySelector('[data-autofocus]') || el.querySelector('button, a, input');
    setTimeout(() => f && f.focus(), 60);
    d.querySelectorAll(`[aria-controls="${id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'true'));
  };
  const closeDrawer = (el) => {
    el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true');
    if (!d.querySelector('.drawer.is-open')) root.classList.remove('no-scroll');
    d.querySelectorAll(`[aria-controls="${el.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
    lastFocus && lastFocus.focus && lastFocus.focus();
  };
  d.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open-drawer]');
    if (opener) { e.preventDefault(); openDrawer(opener.dataset.openDrawer); if (opener.dataset.openDrawer === 'cart-drawer') refreshCart(); return; }
    const closer = e.target.closest('[data-close-drawer]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('.drawer')); }
  });
  d.addEventListener('keydown', (e) => { if (e.key === 'Escape') d.querySelectorAll('.drawer.is-open').forEach(closeDrawer); });

  /* Quantity steppers */
  d.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty]'); if (!b || b.closest('[data-line]')) return;
    const input = b.parentElement.querySelector('input'); if (!input) return;
    const v = Math.max(1, Math.min(99, (parseInt(input.value, 10) || 1) + (b.dataset.qty === 'plus' ? 1 : -1)));
    input.value = v; input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Gallery */
  d.querySelectorAll('[data-gallery]').forEach((g) => {
    const track = g.querySelector('.gallery__slides');
    const slides = [...g.querySelectorAll('.gallery__slide')];
    const ctrls = [...g.querySelectorAll('[data-go]')];
    const set = (i) => ctrls.forEach((c) => c.setAttribute('aria-current', String(+c.dataset.go === i)));
    ctrls.forEach((c) => c.addEventListener('click', () => { const i = +c.dataset.go; track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' }); set(i); }));
    let t; track && track.addEventListener('scroll', () => { clearTimeout(t); t = setTimeout(() => set(Math.round(track.scrollLeft / track.clientWidth)), 60); }, { passive: true });
  });

  /* ---------- Cart ---------- */
  const drawer = d.getElementById('cart-drawer');
  const countEls = () => d.querySelectorAll('[data-cart-count]');
  const threshold = (cfg.freeShippingThreshold || 0) * 100;

  const shipHTML = (total) => {
    if (!threshold) return '';
    const left = threshold - total;
    const pct = Math.min(100, Math.round((total / threshold) * 100));
    const msg = left > 0
      ? `You're <strong>${money(left)}</strong> away from complimentary UK delivery.`
      : `Complimentary UK delivery is included in your order.`;
    return `<div class="cart-ship"><p>${msg}</p><div class="cart-ship__bar" aria-hidden="true"><span style="width:${pct}%"></span></div></div>`;
  };

  const lineHTML = (item, i) => {
    const img = item.image ? item.image + (item.image.includes('?') ? '&' : '?') + 'width=200' : '';
    const plan = item.selling_plan_allocation ? `<div class="cart-item__meta">${item.selling_plan_allocation.selling_plan.name}</div>` : '';
    return `<li class="cart-item" data-line="${i + 1}">
      <a href="${item.url}">${img ? `<img src="${img}" alt="${item.product_title.replace(/"/g, '&quot;')}" width="84" height="105" loading="lazy">` : ''}</a>
      <div>
        <a class="cart-item__title" href="${item.url}">${item.product_title}</a>
        <div class="cart-item__meta">${cfg.preorderNote || ''}</div>${plan}
        <div class="qty" role="group" aria-label="Quantity">
          <button type="button" data-line-qty="minus" aria-label="Decrease quantity">−</button>
          <input type="number" min="0" value="${item.quantity}" aria-label="Quantity" data-line-input>
          <button type="button" data-line-qty="plus" aria-label="Increase quantity">+</button>
        </div>
      </div>
      <div class="cart-item__price">${money(item.final_line_price)}<button type="button" class="cart-item__remove" data-line-remove>Remove</button></div>
    </li>`;
  };

  const upsellHTML = (cart) => {
    if (!threshold || cart.total_price >= threshold || !cfg.upsell || cart.item_count === 0) return '';
    const u = cfg.upsell;
    return `<div class="cart-upsell">
      <img src="${u.image}" alt="" width="56" height="70" loading="lazy">
      <p><strong>Make it two</strong>A second pouch for the cupboard — and delivery is on us.</p>
      <button type="button" class="btn btn--outline" data-upsell-add="${u.variant}">Add ${money(u.price)}</button>
    </div>`;
  };

  const render = (cart) => {
    countEls().forEach((el) => { el.textContent = cart.item_count || ''; el.dataset.count = cart.item_count; });
    if (!drawer) return;
    const body = drawer.querySelector('[data-cart-body]');
    const foot = drawer.querySelector('[data-cart-foot]');
    drawer.querySelector('[data-cart-title-count]').textContent = cart.item_count ? `(${cart.item_count})` : '';
    if (!cart.item_count) {
      body.innerHTML = `<div class="cart-empty"><p class="h3">Your bag is empty.</p><p class="muted">The ritual starts with one pouch.</p><a class="btn" href="${cfg.productUrl}">Shop Hōcha</a></div>`;
      foot.hidden = true; return;
    }
    body.innerHTML = shipHTML(cart.total_price) + `<ul class="cart-items">${cart.items.map(lineHTML).join('')}</ul>` + upsellHTML(cart);
    foot.hidden = false;
    foot.querySelector('[data-cart-total]').textContent = money(cart.total_price);
  };

  const refreshCart = () => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()).then(render).catch(() => {});
  const change = (line, quantity) => fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity }) }).then((r) => r.json()).then(render);
  const add = (items) => fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) })
    .then((r) => r.json().then((j) => { if (!r.ok) throw j; return j; }));

  if (drawer) {
    drawer.addEventListener('click', (e) => {
      const li = e.target.closest('[data-line]');
      if (li) {
        const line = +li.dataset.line, input = li.querySelector('[data-line-input]');
        const b = e.target.closest('[data-line-qty]');
        if (b) { change(line, Math.max(0, (+input.value || 0) + (b.dataset.lineQty === 'plus' ? 1 : -1))); return; }
        if (e.target.closest('[data-line-remove]')) { change(line, 0); return; }
      }
      const up = e.target.closest('[data-upsell-add]');
      if (up) { up.classList.add('is-loading'); add([{ id: +up.dataset.upsellAdd, quantity: 1 }]).then(refreshCart).catch(refreshCart); }
    });
    drawer.addEventListener('change', (e) => {
      const input = e.target.closest('[data-line-input]'); if (!input) return;
      change(+input.closest('[data-line]').dataset.line, Math.max(0, +input.value || 0));
    });
  }

  /* Product forms: AJAX add → open drawer */
  d.querySelectorAll('form[data-product-form]').forEach((form) => {
    form.addEventListener('submit', (e) => {
      if (!drawer) return;
      e.preventDefault();
      const fid = form.getAttribute('id');
      const btns = [...form.querySelectorAll('[type="submit"]'), ...(fid ? d.querySelectorAll(`[form="${fid}"]`) : [])];
      btns.forEach((b) => b.classList.add('is-loading'));
      const fd = new FormData(form);
      const item = { id: +fd.get('id'), quantity: +(fd.get('quantity') || 1) };
      const sp = fd.get('selling_plan'); if (sp) item.selling_plan = +sp;
      const err = form.querySelector('[data-form-error]'); if (err) err.hidden = true;
      add([item]).then(() => refreshCart().then(() => openDrawer('cart-drawer')))
        .catch((j) => { if (err) { err.textContent = (j && (j.description || j.message)) || 'Something went wrong. Please try again.'; err.hidden = false; } })
        .finally(() => btns.forEach((b) => b.classList.remove('is-loading')));
    });
  });

  /* Selling plan toggle (renders only when a subscription app is installed) */
  d.querySelectorAll('[data-plan]').forEach((wrap) => {
    const form = d.getElementById(wrap.dataset.plan);
    const hidden = form && form.querySelector('[name="selling_plan"]');
    wrap.addEventListener('change', (e) => { if (hidden) hidden.value = e.target.value || ''; });
  });

  /* Sticky add to bag */
  const sticky = d.querySelector('[data-sticky-atc]');
  const anchor = d.querySelector('[data-atc-anchor]');
  if (sticky && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(([e]) => {
      const past = !e.isIntersecting && e.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', past);
      sticky.setAttribute('aria-hidden', String(!past));
    }).observe(anchor);
  }

  refreshCart();
})();
